import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

  .form {
    width: 80vw;
    height: 80vh;
    padding: 0 20px;
    background: #ffffff80;

    h1 {
      font-size: 25px;
      color: #3f3d56;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .iputGrup {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 50px;
      gap: 2rem;
      .btn-cancelar {
        width: 160px;
        border: 1px solid #c03333;
        padding: 4px;
        color: #c03333;
        font-weight: 500;
        border-radius: 3px;
        text-align: center;
        border-radius: 8px;
        background-color: #ffffff;
      }

      .btn-salvar {
        width: 180px;
        background-color: #3f3d56;
        padding: 4px;
        color: #ffffff;
        border-radius: 3px;
      }
    }
  }

  .label{
    color: #f90303;
  }

  .btn-termo{
    color: blue;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 1rem;
  }

  @media screen and (max-width: 550px) {
    .iputGrup {
      display: flex;
      flex-direction: column;
      margin-bottom: 0;

      .inputControl{
        padding: 0;
        margin: 0;
      }

      .input-mb{
        margin-bottom: 10px;
      }
    
    }

  }

`;

export const Menu = styled.div`
  width: 100%;
  height: 60px;
  background-color: #d9485d;
  padding: 0 2.5rem;
  align-items: center;
  display: flex;
  .imag {
    img {
      width: 53px;
    }
  }
`;
